import React from 'react';
import { Icon } from 'js/components';
import { TooltipWithBounds } from '@visx/tooltip';
import { formatScore, scoreIcon } from './capabilityTreemapUtils';
import styles from './CapabilityTreemap.module.scss';

export default function CapabilityTooltip({
  tooltipOpen,
  tooltipData,
  tooltipLeft,
  tooltipTop,
}) {
  if (!tooltipOpen || !tooltipData) {
    return null;
  }

  const groupCount = tooltipData.groupCount ?? 0;

  return (
    <TooltipWithBounds
      left={tooltipLeft}
      top={tooltipTop}
      className={styles['tooltip']}
    >
      <div className={styles['tooltip-title']}>
        {tooltipData.label || 'Capability'}
      </div>
      {tooltipData.elementName && (
        <div
          className={`palette-chart-${tooltipData.elementPaletteIndex ?? 2}`}
        >
          <div className={`palette-text ${styles['tooltip-element']}`}>
            {tooltipData.elementName}
          </div>
        </div>
      )}
      <div className={styles['tooltip-row']}>
        <div>
          <Icon
            icon={scoreIcon(tooltipData.score)}
            className={`icon icon-left ${styles['tooltip-icon']}`}
            fixedWidth
          />
          {formatScore(tooltipData.score)}
        </div>
        {groupCount > 0 && (
          <div>
            {groupCount} group{groupCount === 1 ? '' : 's'}
          </div>
        )}
      </div>
    </TooltipWithBounds>
  );
}
